import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className={`block overflow-hidden pb-[0.08em] ${className}`}>
    <motion.span
      className="block will-change-transform"
      initial={{ y: "110%", rotate: 2 }}
      animate={{ y: "0%", rotate: 0 }}
      transition={{ duration: 1.1, ease, delay }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease, delay }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ children, light = false }) => (
  <p className={`font-mono-d text-xs uppercase tracking-[0.25em] font-medium flex items-center gap-3 ${light ? "text-[#E8A27F]" : "text-[#B04E2A]"}`}>
    <span className={`h-px w-8 ${light ? "bg-[#E8A27F]" : "bg-[#B04E2A]"}`} />
    {children}
  </p>
);
